module.exports = __webpack_public_path__ + "static/Akebia_MOD_Animation_01_Burden_of_Anemia_due_to_CKD-d46b8933ca39910bb9a11d567353cd5c.mp4";